import React from 'react';
import './PolicyPage.scss';
import HeaderPolicy from '../../components/Header/HeaderPolicy';
import LayoutPolicy from '../../components/Layout/LayoutPolicy';

function SalusPrivacyPage() {
    const titleText = "살루스케어 개인정보 처리 방침";

    return (
        <div className="policy" id="wrap">
            {/* header */}
            <HeaderPolicy title={titleText} />

            {/* contents, footer */}
            <LayoutPolicy>
                <div className="contents-new-agree__text">
                    <span>
                        (주)살루스케어(이하 ‘회사’라 함)는 개인정보보호법 및 관계법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 이에 개인정보보호법 제30조에 따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리방침을 수립, 공개합니다.
                    </span>
                </div>

                <div className="contents-new-agree__text">
                    <span>
                        또한 관련 법령에 따른 개인정보처리방침을 정하여 비타포트 사이트 및 서비스에 공개하여 “회원”이 언제나 용이하게 열람할 수 있도록 하고 있습니다. 회사는 법령 및 정부의 지침의 변경 등에 따라 수시로 개인정보처리방침을 바꿀 수 있으며, 이에 따른 개인정보처리방침의 지속적인 개선을 위하여 필요한 절차를 정하고 있습니다.
                    </span>
                </div>

                <div className="contents-new-agree__text">
                    <span>
                        본 개인정보처리방침은 회사가 제공하는 “비타포트 홈페이지([www.vitaport.co.kr](http://www.vitaport.co.kr/), [m.vitaport.co.kr](http://m.vitaport.co.kr/))” 및 비타포트 서비스(이하 ‘서비스’라 한다.)이용에 적용되며 다음과 같은 내용을 담고 있습니다.
                    </span>
                </div>

                <div className="contents-new-agree__img privacy_1">
                    <img alt=""/>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        [목차]
                    </span>
                </div>

                <div className="contents-new-agree__text index">
                    <span>제 1 조 개인정보 처리 목적, 수집 항목, 보유/이용기간</span>
                    <span>제 2 조 개인정보의 처리 및 보유기간</span>
                    <span>제 3 조 개인정보의 제 3자에 대한 제공</span>
                    <span>제 4 조 개인정보 처리 업무의 위탁</span>
                    <span>제 5 조 개인정보 파기절차 및 방법</span>
                    <span>제 6 조 개인정보주체의 권리와 의무 및 그 행사방법</span>
                    <span>제 7 조 개인정보 처리 방침의 고지 또는 통지 방법 등</span>
                    <span>제 8 조 개인정보보호를 위한 기술 및 관리적 조치</span>
                    <span>제 9 조 개인정보 자동 수집 장치의 설치, 운영 및 거부</span>
                    <span>제 10 조 행태정보의 수집, 이용, 제공 및 거부</span>
                    <span>제 11 조 링크 사이트에 대한 책임</span>
                    <span>제 12 조 게시물에 대한 책임</span>
                    <span>제 13 조 개인정보관련 의견수렴 및 침해, 불만처리에 관한 사항</span>
                    <span>제 14 조 개인정보 보호책임자 및 담당자</span>
                    <span>제 15조 가명정보의 처리</span>
                    <span>제 16 조 광고성 정보 전송</span>
                    <span>제 17 조 개인정보처리방침 고지의무</span>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 1 조 (개인정보의 처리 목적, 수집 항목, 보유/이용기간)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 회원가입, 원활한 고객상담, 각종 서비스의 제공 등 아래 각호와 같은 목적을 위하여 최소한의 개인정보를 필수항목으로 수집하고 있으며, “회원” 각자의 기호와 필요에 맞는 서비스를 제공하기 위하여 개인정보 수집 시 별도의 동의를 얻고 있습니다. 선택 정보를 입력하지 않아도 서비스 이용에 제한은 없습니다.</span>
                    </div>
                </div>

                <div className="horizon-scroll-area">
                    <div className="horizon-scroll">
                        <div className="contents-new-agree__img privacy_2">
                            <img alt=""/>
                        </div>
                    </div>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회사는 본 개인정보처리방침을 서비스 내에 공개함으로써 “회원”이 언제나 용이하게 보실 수 있도록 조치하고 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>회사는 개인정보처리방침의 지속적인 개선을 위하여 개인정보처리방침을 개정, 변경 등을 하는데 있어 필요한 절차를 정하고 있습니다. 그리고 개인정보처리방침을 개정, 변경 등을 하는 경우 개인정보처리방침의 버전번호, 신·구조문 대조표 등을 서비스 내에 게시 또는 “회원”에게 공지하여 개정, 변경 등이 된 사항에 관하여 “회원”이 쉽게 알아볼 수 있도록 하고 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>서비스이용에 필요한 아이디(ID)를 이용한 부가 서비스 및 맞춤식 서비스의 이용 또는 이벤트 응모 과정에서 해당 서비스의 “회원”에 한하여 부가적인 개인정보들이 수집될 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑤</span>
                        <span>"회사"는 이용계약 회원의 복약관리, 건강검진, 콘텐츠 기록 이용 기록을 개인정보보호법, 서비스 이용약관 제 38조 등에 따라 통계작성, 과학적 연구, 공익적 기록보존 등을 위하여 별도의 백업 DB에 해당 정보를 가명처리를 하여 분리 보관할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑥</span>
                        <span>“회사”는 “서비스” 제공을 위해 이용약관” 제 38조, 제 39조의 통계자료를 가공할 수 있습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 2 조 (개인정보의 처리 및 보유 기간)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 관련 법령 및 본 약관에 따른 개인정보 보유∙이용기간 또는 “회원”으로부터 개인정보를 수집 시 동의 받은 개인정보 보유기간 내에서 개인정보를 처리∙보유합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>“회원”의 개인정보는 수집의 목적 또는 제공받은 목적이 달성되거나 “회원”이 보유 기간이 만료된 경우 지체없이 파기하는 것을 원칙으로 합니다. 또한, 일시적인 목적(이벤트 등)으로 입력 받은 개인정보는 그 목적이 달성된 이후에는 동조 제2항 본문과 동일한 방법으로 처리됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>제2항에도 불구하고 회사는 “회원”의 부정한 이용 등을 방지하기 위하여 이용계약의 해지일(회원탈퇴일 등)로부터 근거법령에 따른 보존기간 동안 해당 “회원”의 개인정보를 보유할 수 있으며 상법 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 아래 내용을 포함한 관계법령에서 정한 일정한 기간 동안 “회원”의 개인정보를 보관하며, 이 경우 회사는 보관하는 개인정보를 그 보관의 목적으로만 이용합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__img privacy_3">
                    <img alt=""/>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 3 조 (개인정보의 제3자에 대한 제공)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 이용자의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회사는 제3자 서비스와의 연결을 위하여 “회원”의 동의를 얻은 후에 아래와 같이 제휴사 등에게 “회원”의 개인정보를 제공하고 있습니다.</span>
                    </div>
                </div>

                <div className="horizon-scroll-area">
                    <div className="horizon-scroll">
                        <div className="contents-new-agree__img privacy_4">
                            <img alt=""/>
                        </div>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 4 조 (개인정보 처리 업무의 위탁)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 서비스의 제공, 고객편의 등의 원활한 업무 수행을 위하여 아래와 같이 개인정보 처리 업무를 외부전문업체에 위탁하여 운영하고 있습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__img privacy_5">
                    <img alt=""/>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>“회원”의 개인정보를 위탁 처리하는 경우에는 위탁계약(위탁업무 수행 목적 외 개인정보 처리 금지, 개인정보의 기술적 관리적 보호조치, 위탁업무의 목적 및 범위, 재 위탁 제한, 개인정보에 대한 접근 제한 등 안정성 확보 조치, 위탁업무와 관련하여 보유하고 있는 개인정보의 관리 현황 점검 등 감독, 수탁자가 준수하여야 할 의무를 위반한 경우의 손해배상 등의 내용이 포함됨)을 통하여 수탁업체의 개인정보보호 관련 지시엄수, 개인정보에 관한 비밀유지, 제3자 제공의 금지 및 사고 발생시 법적 책임부담 등을 명확히 규정하고 당해 계약내용을 서면 또는 전자적으로 보관할 것입니다. 또한, 회사는 위탁계약에 따른 위탁업무의 내용, 개인정보 처리업무를 위탁 받아 처리하는 자(수탁업체)를 “회원”이 언제든지 쉽게 확인할 수 있도록 회사의 ‘서비스’에 지속적으로 게재하여 공개합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="numbe_ringr">③</span>
                        <span>회사는 업무를 위한 개인정보의 위탁 처리로 인하여 “회원”의 개인정보가 분실, 도난, 유출, 변조, 훼손되지 아니하도록 수탁자를 교육하고 수탁자가 개인정보를 안전하게 처리하는 지를 관리·감독할 것입니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 5 조 (개인정보 파기절차 및 방법)
                    </span>
                </div>

                <div className="contents-new-agree__text">
                    <span>
                        ‘회사’는 “회원”의 개인정보는 원칙적으로 보유기간의 경과, 개인정보의 수집 및 이용목적 달성 등으로 인하여 해당개인정보가 불필요하게 되었을 때에는 지체 없이 파기합니다. 회사의 개인정보 파기절차 및 방법은 다음과 같습니다.
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>파기절차</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>‘회사’는 개인정보의 파기에 관한 사항을 기록하고 관리하며, 파기는 개인정보 보호책임자의 책임하에 수행되며, 개인정보 보호책임자는 파기 결과를 확인합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>‘회사’는 다른 법령에 따라 보존해야 하는 경우에는 예외적으로 “회원”의 개인정보를 파기하지 않을 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>파기방법</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>‘회사’는 종이나 그 밖의 기록매체에 저장된 개인정보는 파쇄하거나 소각합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>전자적 파일 형태로 저장된 개인정보는 복원이 불가능한 방법(내지 기록을 재생할 수 없는 기술적 방법)으로 영구 삭제합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>미파기 정보의 보존방법</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>회사는 통신비밀보호법 등 관련 법령에 따라 개인정보를 파기하지 않고 보존하는 경우에 해당 개인정보 또는 개인정보파일을 다른 개인정보와 분리하여 저장 관리합니다. 회사는 별도 DB로 옮기거나 보관장소를 달리하여 보존한 개인정보를 법률에 의한 경우가 아니고서는 보유하는 이외의 다른 목적으로 이용하지 않습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 6 조 (개인정보주체의 권리와 의무 및 그 행사방법)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>“회원”은 언제든지 회사에 “비타포트” 서비스를 통하여 등록되어 있는 자신의 개인정보, 회사의 개인정보를 이용 또는 제3자에게 제공한 현황, 회사에 대하여 개인정보 수집, 이용, 제공 등의 동의를 한 현황에 대하여 열람이나 제공을 요구할 수 있고, 오류가 있는 경우에는 정정, 변경 등을 요구할 수 있으며, 삭제 내지 이용계약의 해지를 요구할 수도 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>“회원”의 개인정보 조회, 변경, 정정 등을 위해서는 ‘개인정보변경’을, 이용계약의 해지(동의철회 등)를 위해서는 “회원탈퇴”를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>동조 제1항과 제2항의 경우, 회사는 지체 없이 해당 “회원”의 개인정보를 조회하여 “회원”의 요구에 따른 정정, 변경, 삭제 등 필요한 조치를 한 후 그 결과를 “회원”에게 지체없이 알립니다. 회사는 필요한 조치를 완료할 때까지는 해당 개인정보를 이용하거나 제3자에게 제공하지 않는 등 해당개인정보 처리의 전부 내지 일부를 정지하며, 처리가 정지된 개인정보에 관하여 지체 없이 그 개인정보의 파기 등 필요한 조치를 취합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>개인정보처리 등과 관련하여 이의나 의견이 있는 “회원”은 개인정보 보호책임자 및 담당자에게 서면, 전화 또는 이메일(E-mail) 등으로 연락하면 회사는 접수 및 즉시 처리를 하고 결과를 해당 “회원”에게 알립니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑤</span>
                        <span>“회원”은 본조의 권리 행사를 법정대리인이나 위임을 받은 자 등 대리인을 통하여 할 수 있으며, 이 경우 “회사”는 위임장, 신분증 등을 통하여 정당한 대리인, 수임인인지 확인합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 7 조 (개인정보 처리 방침의 고지 또는 통지 방법 등)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 “회원”이 동의한 범위를 넘어 해당 “회원”의 개인정보를 이용하거나 제3자에게 제공하기 위해서는 “회원”에게 별도의 동의를 얻어야 하며, 별도 동의를 얻기 위해서 “회원”에게 개별적으로 카카오톡, 문자(SMS, MMS 등), 전자우편(E- mail) 등의 방법으로 해당사항을 알립니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>제3자에게 “회원”의 개인정보 수집·보관·처리·이용·제공·관리·파기 등을 위탁할 때에는 가입 화면, 서비스 이용약관, 개인정보처리방침 등을 통하여 해당 사실을 “회원”에게 고지하고 알리고 동의를 얻습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>회사가 영업의 전부 또는 일부를 양도하거나 합병·상속 등으로 권리와 의무를 제3자에게 이전하는 경우에는 서면, 이메일(E-mail) 등을 통하여 “회원”에게 개별적으로 알리는 동시에 해당 사실을 서비스 등의 첫 화면에서 표시하고 30일 이상 그 사실을 공지합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 8 조 (개인정보보호를 위한 기술 및 관리적 조치)
                    </span>
                </div>

                <div className="contents-new-agree__text">
                    <span>
                        “회사”는 “회원”의 개인정보 등을 보호하기 위해 기술적 조치와 관리적 조치를 마련하고 있으며, 이를 적용하고 있습니다.
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>기술적 조치</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>회사는 “회원”의 개인정보를 처리할 때 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 다음과 같은 기술적 조치를 마련하여 개인정보의 안전성을 확보하고 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>“회원”의 개인정보는 비밀번호(Password)로 보호되며 중요한 데이터는 파일 및 전송데이터를 암호화하거나 파일 잠금기능 (Lock)을 사용하여 중요한 데이터는 별도의 보안기능으로 보호됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>회사는 암호 알고리즘을 이용하여 네트워크 상의 개인정보를 안전하게 전송할 수 있는 보안장치(SSL 또는 SET)를 채택하고 있습니다. 해킹 등 외부침입에 대비하여 각 서버마다 침입차단시스템과 취약점 분석시스템 등을 이용하여 보안에 최선을 다하고 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>관리적 조치</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1.</span>
                        <span>회사는 “회원”의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있으며 이에 해당하는 자는 아래 각목과 같습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">1. </span>
                        <span>“회원”을 직접 상대로 하여 마케팅 업무를 수행하는 자(회원이 마케팅 목적의 개인정보 수집에 동의한 경우에 한함)</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">2. </span>
                        <span>“회원” 구분을 위해 통계 분석 업무를 수행하는 자(개인정보보호법 제28조제3항 등 관련 법령을 준수함)</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">3. </span>
                        <span>“회원”에게 회원이 동의한 개인정보 수집 목적 범위 내 서비스를 제공하기 위하여 개인정보의 취급이 불가피한 자</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">4. </span>
                        <span>개인정보보호책임자와 담당자 등 개인정보보호업무를 수행하는 자</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2.</span>
                        <span>회사는 “회원”의 개인정보에 대한 접근과 관리에 필요한 절차 등을 마련하여 소속 직원으로 하여금 이를 숙지하고 지키도록 하고 있으며, 개인정보를 처리하는 직원을 대상으로 새로운 보안 기술 습득 및 개인정보보호 의무 등에 관해 정기적인 사내 교육과 외부 위탁교육을 시행하고 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">3.</span>
                        <span>개인정보 관련 처리자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며 입사 및 퇴사 후 개인정보 유출 위험 및 이와 관련된 문제를 예방하기 위한 책임을 명확히 하고 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">4.</span>
                        <span>회사는 컴퓨터를 이용하여 “회원”의 개인정보를 처리할 때에는 개인정보에 접근 권한이 있는 담당자를 지정하여 담당자에게 아이디(ID)과 비밀번호(Password)를 부여하고, 해당 비밀번호(Password)를 정기적으로 갱신하고 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">5.</span>
                        <span>회사는 신규로 채용된 직원에게 정보보호서약서 또는 개인정보보호서약서에 서명하게 하여 직원에 의한 정보유출을 미리 방지하고 있으며, 개인정보처리방침에 대한 이행 사항과 직원의 준수여부를 감사하기 위한 내부절차를 마련하여 지속적으로 시행하고 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">6.</span>
                        <span>회사는 직원 퇴직 시 비밀유지서약서에 서명함으로 회원의 개인정보를 처리하였던 자가 직무상 알게 된 개인정보를 훼손·침해 또는 누설하지 않도록 하고 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">7.</span>
                        <span>회사는 “회원” 개인의 실수나 기본적인 인터넷의 위험성으로 인하여 발생하는 문제에 대하여 책임을 지지 아니합니다. “회원” 본인은 개인정보를 보호하기 위해서 자신의 이메일(E-Mail) 과 비밀번호(Password)를 적절하게 관리하고 그에 대한 책임을 져야 합니다. 다른 사람이 추측할 수 있는 쉬운 비밀번호(Password)는 사용하지 않기를 권장하며, 정기적으로 비밀번호(Password)를 변경하시는 것이 바람직합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">8.</span>
                        <span>공동으로 사용하는 모바일 단말기에서 비타포트 서비스에 접속하여 로그인 한 상태에서 서비스 이용을 종료할 때에는 반드시 로그아웃 처리 후 해당 서비스를 종료하시기 바랍니다. 그렇지 않으면 해당 모바일 단말기에 설치된 비타포트 서비스를 통해 이메일(E-Mail), 비밀번호(Password) 등 “회원”의 정보가 타인에게 쉽게 유출될 우려가 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">9.</span>
                        <span>그 밖에 내부 관리자의 실수나 기술관리 상의 사고로 “회원”의 개인정보가 유출·변조·훼손이 되면 회사는 지체없이 “회원”에게 해당 사실을 알리고 적절한 대책과 보상을 마련할 것입니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>물리적 대책</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1.</span>
                        <span>사무실 접근통제</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span>​​사무실 개인정보가 보호된 자체 서버실은 일반 출입이 제한되어 관리자 외에는 접근이 불가능합니다. 자체 서버실은 시건 장치로 관리됩니다. 출입자는 용무를 밝히고 개인 정보를 입력한 후에만 출입할 수 있습니다. CCTV 시스템, 출입통제시스템, 침입 경보시스템 등을 통해 허가 받지 않은 사람들의 출입이 감시되고 통제됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2.</span>
                        <span>전기 배선 등​​</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span>​​​​건물 전기관리자와 협의 하에 효율적/안정적으로 배선 및 전용망을 관리하며 지속적이고 안정적인 서비스 제공을 위해서 주기적으로 안전 점검을 시행합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">3.</span>
                        <span>자체 서버 및 정보통신센터의 설비에 대한 정기 점검 등​</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span>​​​​​​​자체 서버실의 서버는 매일 점검하며, 분기마다 정기 점검을 시행합니다. 점검 항목에는 RACK 점검, Network 장비, 전력공급선 점검, 서버 케이블 점검 및 보안성 점검 등이 포함됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-0">
                        <span>-기타 필요한 경우 수시로 점검합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 9 조 (개인정보 자동 수집 장치의 설치·운영 및 거부)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 회원(정보주체)에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 운용합니다. 회원은 웹브라우저의 보안 정책 변경을 통해 쿠키에 의한 개인정보 수집의 허용 여부를 결정하실 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>쿠키의 정의 및 저장 방법 : 쿠키(Cookie)는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다. 쿠키의 경우 고객의 유·무선 단말기는 식별하지만 고객 개개인을 식별하지는 않습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">3. </span>
                        <span>거부 설정 방법 : 다음의 방법을 통한 옵션 설정을 통해 쿠키 저장을 거부할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">A. </span>
                        <span>Internet Explorer의 경우 : 웹 브라우저 상단의 도구 메뉴 &gt; 인터넷 옵션 &gt; 개인정보 &gt; 고급</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">B.</span>
                        <span>Chrome의 경우 : 웹 브라우저 상단의 맟춤설정 및 제어 &gt; 설정 &gt; 개인정보 및 보안 &gt; 쿠키 및 기타 사이트 데이터</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">C.</span>
                        <span>쿠키는 브라우저의 종료 시나 로그아웃 시 만료됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">D.</span>
                        <span>쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering four-depth">
                        <span className="dash">-</span>
                        <span>IP Address 정보 수집</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="dash">1.</span>
                        <span>IP Address는 인터넷 망 사업자가 인터넷에 접속하는 이용자의 PC 등 기기에 부여하는 온라인 주소정보를 나타냅니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering four-depth">
                        <span className="dash">-</span>
                        <span>기기정보 수집</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="dash">1.</span>
                        <span>기기의 구동을 위해 사용되는 S/W를 통해 확인가능한 정보를 일컫습니다. OS(Windows, MAC OS 등), 접속한 브라우저 종류(인터넷 익스플로러, 크롬 등) 등을 수집합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 10 조 (행태정보의 수집, 이용, 제공 및 거부)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 회원의 서비스 이용 분석에 활용하여 최적화된 맞춤형 서비스, 온라인 맞춤형 광고 등을 제공하기 위해 온라인 행태정보를 수집·이용하고 있습니다. 행태정보란 웹사이트 방문 이력, 앱 사용 이력 등 이용자의 관심, 흥미, 기호 및 성향 등을 파악하고 분석할 수 있는 온라인상의 이용자 활동정보를 말합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회사는 다음과 같이 행태정보를 수집합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__img privacy_6">
                    <img alt=""/>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>서비스 이용 분석에 필요한 최소한의 행태정보만을 수집하며, 사상, 신념, 가족 및 친인척관계, 학력·병력, 기타 사회활동 경력 등 개인의 권리·이익이나 사생활을 뚜렷하게 침해할 우려가 있는 민감한 행태정보를 수집하지 않습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>이용자는 웹브라우저의 쿠키 설정 변경 등을 통해 온라인 맞춤형 광고를 일괄적으로 차단·허용할 수 있습니다. 다만, 쿠키 설정 변경은 웹사이트 자동로그인 등 일부 서비스의 이용에 영향을 미칠 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth mt-4">
                        <span className="number">1. </span>
                        <span>인터넷 익스플로러(Windows 10용 Internet Explorer 11)</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>Internet Explorer에서 도구 버튼을 선택한 다음 인터넷 옵션을 선택</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>개인 정보 탭을 선택하고 설정에서 고급을 선택한 다음 쿠키의 차단 또는 허용을 선택</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth mt-2">
                        <span className="number">2. </span>
                        <span>Microsoft Edge</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>Edge에서 오른쪽 상단 ‘…’ 표시를 클릭한 후, 설정을 클릭합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>설정 페이지 좌측의 ‘개인정보, 검색 및 서비스’를 클릭 후 「추적방지」 섹션에서 ‘추적방지’ 여부 및 수준을 선택합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>'InPrivate를 검색할 때 항상 "엄격" 추적 방지 사용' 여부를 선택합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>아래 「개인정보」 섹션에서 ‘추적 안함 요청보내기’ 여부를 선택합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth mt-2">
                        <span className="number">3. </span>
                        <span>크롬 브라우저</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>Chrome에서 오른쪽 상단 ‘⋮’ 표시(chrome 맞춤설정 및 제어)를 클릭한 후, 설정 표시를 클릭합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>설정 페이지 하단에 ‘고급 설정 표시’를 클릭하고 「개인정보」 섹션에서 콘텐츠 설정을 클릭합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑤</span>
                        <span>회원은 아래의 연락처로 행태정보와 관련하여 궁금한 사항과 거부권 행사, 피해 신고 접수 등을 문의할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="dash">-</span>
                        <span>개인정보 담당 부서</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>부서 : IT 팀</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>담당자 : 이인호</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>연락처 : 02-6324-8000</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 11 조 (링크 사이트에 대한 책임)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 “회원”에게 다른 회사의 웹사이트 또는 자료에 대한 링크를 제공할 수 있습니다. 이 때 회사는 외부사이트와 자료에 대해 아무런 통제권이 없으므로 해당 사이트에서 제공받는 서비스나 자료의 진실성, 유용성 등에 대해 책임지지 않으며, 어떠한 법적 책임도 지지 않습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>서비스에 포함하고 있는 링크를 클릭하여 다른 사이트(site)의 페이지로 옮겨갈 경우 해당 사이트의 개인정보처리방침 등은 회사와 무관하므로 새로 방문한 사이트의 정책을 반드시 검토하시기 바랍니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 12 조 (게시물에 대한 책임)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 “회원”의 게시물을 소중하게 생각하며 해당 게시물이 변조, 훼손, 삭제되지 않도록 최선을 다하여 보호합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>스팸(spam)성 게시물, (예 : 특정사이트에 대한 광고, 다른 사이트로의 유도 광고 및 링크 등) 타인을 비방할 목적으로 사실 또는 허위 사실을 게시하여 타인의 명예를 훼손하는 글, 동의 없이 타인의 신상공개, 회사의 저작권, 혹은 제3자의 지적재산권 등의 법적 권리를 침해하는 내용,기타 게시판의 목적과 다른 내용의 게시 등을 하는 경우에는 특정부분을 삭제하거나 기호 등으로 수정 또는 블라인드 등의 조치를 할 수 있습니다. 그 밖의 경우에는 명시적 또는 개별적인 경고 후 삭제 조치할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>다른 주제의 게시판으로 이동할 수 있는 게시물은 해당 게시물의 이동 경로를 밝혀 오해가 없도록 하고 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>기본적으로 게시물에 관련된 제반 권리와 책임은 작성자 개인에게 있습니다. 또한 게시물을 통해 자발적으로 공개된 정보는 보호받기 어려우므로 정보 공개 전에 심사숙고한 후 서비스를 이용해야 합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 13 조 (개인정보관련 의견수렴 및 침해, 불만처리에 관한 사항)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 개인정보보호와 관련하여 “회원”의 의견을 수렴하고 있으며 불만을 처리하기 위하여 모든 절차와 방법을 마련하고 있습니다. “회원”은 하단에 명시한 개인정보 보호책임자 및 담당자” 항을 참고하여 전화나 메일 등을 통하여 불만사항을 신고할 수 있고, 회사는 “회원”의 신고사항에 대하여 신속하게 처리하여 답변해 드립니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>기타 개인정보 침해에 관한 상담이 필요한 경우에는 정부에서 설치하여 운영 중인 기관에 불만처리를 신청할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>개인정보침해신고센터 :(국번없이)118 ( http://privacy.kisa.or.kr)</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>개인정보분쟁조정위원회 :1833-6972( http://kopico.go.kr)</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>대검찰청 사이버수사과 :(국번없이)1301, cid@spo.go.kr ( http://spo.go.kr)</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>경찰청 사이버안전국 :(국번없이)182 ( http://cyberbureau.police.go.kr)</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 14 조 (개인정보 보호책임자 및 담당자)
                    </span>
                </div>

                <div className="contents-new-agree__text pb-4">
                    <span>
                        회사는 “회원”이 좋은 정보를 안전하게 이용할 수 있도록 최선을 다하고 있습니다. 개인정보를 보호하는데 있어 귀하께 고지한 사항들에 반하는 사고가 발생할 경우 개인정보보호책임자가 책임을 집니다. 그러나 기술적인 보완조치를 했음에도 불구하고, 해킹 등 기본적인 네트워크 상의 위험성에 의해 발생하는 예기치 못한 사고로 인한 개인정보의 훼손 및 방문자가 작성한 게시물에 의한 각종 분쟁에 관해서 회사는 책임이 없습니다. “회원”의 개인정보를 취급하는 책임자 및 담당자는 다음과 같으며 개인정보 관련 문의사항에 신속하고 성실하게 답변해드리고 있습니다.
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">-</span>
                        <span>개인정보 보호책임자</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth dash">
                        <span className="dash">-</span>
                        <span>이름 : 이인호</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth dash">
                        <span className="dash">-</span>
                        <span>소속/직위 : IT 팀</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth dash">
                        <span className="dash">-</span>
                        <span>이 메 일 : [ihlee@saluscare.co.kr]<br className="mo" />
                            (mailto:ihlee@saluscare.co.kr)</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 15 조 (DID를 포함한 가명정보의 처리)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 통계작성, 과학적 연구, 공익적 기록보존 등을 위하여 수집한 개인정보를 특정 개인을 알아볼 수 없도록 가명처리하여 다음과 같이 처리하고 있으며, 개인정보보호법 제28조의4에 따라 가명정보의 안전성 확보조치를 시행하고 있습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__img privacy_7">
                    <img alt=""/>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회사는 본 개인정보처리방침에 따라 “회원”의 동의 하에 그 목적 범위 내에서 “회원”의 개인정보를 수집하나, 한편 회사는 그와 별도로 “회원”의 고유한 탈중앙화 DID(Decentralized Indentifier)를 발급하여 저장합니다. 해당 DID값은 개인을 식별할 수 없고, “회원” 데이터의 안전한 관리 및 활용에 사용되며 “회원”의 동의가 없이 임의로 이용되지 않습니다[1] [2] . 회사는 이와 관련하여 개인정보호법 제3절 [가명정보의 처리에 관한 특례] 제반 규정을 준수합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>회사가 “회원”의 DID를 생성하는 과정은 다음과 같습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>DID생성</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>SDK를 통해 지갑 생성에 필요한 random 단어들을 만듭니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>SDK를 통해 random 단어들을 이용해 프라이빗 키를 받습니다(프라이빗 키는 “회원”의 기기에 저장합니다).</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>SDK를 통해 프라이빗 키를 이용해 DID를 만듭니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>암호화​ 대상​​​​</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth mt-2">
                        <span className="dash">-</span>
                        <span>“회원”의 아이디(가입 시 이메일), 이용약관 동의 시점(시간대)을 SDK를 이용해 DID로 서명합니다. 암호화된 정보는 개인을 식별할 수 없는 경우에 한하여 제3자에게 제공될 수 있으며 사용 시 “회원”에게 제공된 프라이빗 키가 필요합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 16 조 (광고성 정보 전송)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 “회원”의 사전 동의를 받지 않은 영리목적의 광고성 정보를 전송하지 않습니다. 단, 아래의 경우에는 「정보통신망 이용촉진 및 정보 보호 등에 관한 법률」 제50조에 근거하여 사전 동의 없이 광고성 정보를 전송할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="dash">-</span>
                        <span>재화 등의 거래관계를 통하여 고객으로부터 직접 연락처를 수집한 자가 6개월 이내에 자신이 처리하고 고객과 거래한 것과 동종의 재화 등에 대한 영리목적의 광고성 정보를 전송하려는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회사는 “회원”이 광고성 정보에 관한 수신거부의사를 표시하거나 사전 동의를 철회할 경우 영리목적의 광고성 정보를 전송하지 않습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 17 조 (개인정보처리방침 고지의무)
                    </span>
                </div>

                <div className="contents-new-agree__text pb-4">
                    <span>
                        현 개인정보처리방침은 2024년 05월 24일에 제정되었으며 정부의 정책 또는 보안기술의 변경에 따라 내용의 추가, 삭제 및 수정이 필요하면 일반적 내용은 개정 최소 7일 전까지 서비스의 ’공지’란을 통해 알릴 것입니다.
                    </span>
                </div>
            </LayoutPolicy>
        </div>
    )
}

export default SalusPrivacyPage;
